"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('experiment', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M12 4H36",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.019 4V15.0386L6.27443 39.3014C5.48692 40.9283 6.16737 42.8855 7.79427 43.673C8.23882 43.8882 8.7263 44 9.22019 44H38.7875C40.595 44 42.0602 42.5347 42.0602 40.7273C42.0602 40.2348 41.9491 39.7488 41.7351 39.3052L30.0282 15.0386V4H18.019Z",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M10.9604 29.9998C13.1241 31.3401 15.2893 32.0103 17.4559 32.0103C19.6226 32.0103 21.7908 31.3401 23.9605 29.9998C26.1088 28.6735 28.2664 28.0103 30.433 28.0103C32.5997 28.0103 34.7755 28.6735 36.9604 29.9998",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }));
});

exports.default = _default;